///
/// EarthBrowser
///
/// Created by Matt Giger on 10/23/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Altitude ramps shared by the precipitation overlays (global radar mosaic,
/// its Web Mercator refinement tiles, IMERG). Radar and satellite
/// precipitation are the quantitative figure of a weather view, so unlike
/// the day/night lighting ramp (1500-4500 km) these keep the echoes at
/// full strength down to local views and only ease back near street level
/// where the base map has to read for navigation. The shaders turn the
/// scale into an opacity: mix(low, high, scale).
///

import { clamp } from "@stovokor/math/math"

// Echo opacity ramp (km above the ellipsoid): full above cPrecipHighKm,
// eased back below cPrecipLowKm
const cPrecipLowKm = 40
const cPrecipHighKm = 150

// Hand-off from the ~10 km/px equirect radar mosaic to the Web Mercator
// refinement tiles (selected below ~1250 km, EarthTileUpdateTask). Both
// draw through the middle of the range; the mosaic is gone by the time its
// texels are blocks on screen, so the sharp tiles aren't stacked on a
// blurry copy of themselves
const cMosaicLowKm = 300
const cMosaicHighKm = 700

/** 1 from regional views up, 0 at street level */
export function precipAltitudeScale(altitudeKm: number): number {
	return clamp((altitudeKm - cPrecipLowKm) / (cPrecipHighKm - cPrecipLowKm), 0, 1)
}

/** 1 while the equirect mosaic carries the radar, 0 once the refinement tiles own it */
export function radarMosaicScale(altitudeKm: number): number {
	return clamp((altitudeKm - cMosaicLowKm) / (cMosaicHighKm - cMosaicLowKm), 0, 1)
}
